import type { ReactNode } from 'react';
import type { UseFormHandleSubmit } from 'react-hook-form';
import type { CreateCargoProblemWorkspaceInput } from '@magimp/shared';
import { Button, useEditorGuard } from '../../../ui/index.js';

export function GuardedProblemForm({
  handleSubmit,
  submit,
  children,
}: {
  handleSubmit: UseFormHandleSubmit<CreateCargoProblemWorkspaceInput>;
  submit: (values: CreateCargoProblemWorkspaceInput, bypassNext: () => void) => Promise<void>;
  children: ReactNode;
}) {
  const { bypassNext } = useEditorGuard();
  return (
    <form
      className="cargo-problem-editor"
      onSubmit={handleSubmit((values) => submit(values, bypassNext))}
    >
      {children}
    </form>
  );
}

export function GuardedCloseAction({
  label,
  iconOnly = false,
  onClose,
}: {
  label: string;
  iconOnly?: boolean;
  onClose: () => void;
}) {
  const { confirmDestructive } = useEditorGuard();
  return iconOnly ? (
    <Button kind="quiet" icon="x" aria-label={label} onClick={() => confirmDestructive(onClose)} />
  ) : (
    <Button kind="ghost" onClick={() => confirmDestructive(onClose)}>
      {label}
    </Button>
  );
}
